import { MERCH_CARD } from '../../../constants/tracking/TrackingSources';
import { useAppSelector } from '../../../reducers';
import { isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';
import { skuSelector } from '../../../selectors/ProductsSelectors';
import IncludedContacts from './IncludedContacts';
import { IncludedUsers } from './IncludedUsers';
import { jsx as _jsx } from "react/jsx-runtime";
export const SubtextDisplayContainer = ({
  additionalUnitSkuId,
  queryParamTerm,
  productLine,
  productLevel
}) => {
  const isSeatsRedesignUngated = useAppSelector(isUngatedForSeatsSelector);
  const quantityPackApiName = useAppSelector(state => {
    if (!additionalUnitSkuId) {
      return null;
    }
    const sku = skuSelector(state, {
      skuId: additionalUnitSkuId
    });
    return sku === null || sku === void 0 ? void 0 : sku.quantityPackApiName;
  });
  if ((quantityPackApiName === 'additional-sales-seats' || quantityPackApiName === 'additional-service-seats') && !isSeatsRedesignUngated) {
    return /*#__PURE__*/_jsx(IncludedUsers, {
      quantityPackSkuId: additionalUnitSkuId,
      productLine: productLine,
      productLevel: productLevel
    });
  } else if (quantityPackApiName === 'additional-marketing-contacts' || quantityPackApiName === 'additional-legacy-contacts') {
    return /*#__PURE__*/_jsx(IncludedContacts, {
      quantityPackSkuId: additionalUnitSkuId,
      trackingSource: MERCH_CARD,
      queryParamTerm: queryParamTerm
    });
  }
  return null;
};